import styled from 'styled-components';

export const UserContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  table {
    width: 100%;
  }
`;

export const PaginationButtonContainer = styled.div`
  text-align: right; /* Alinha o conteúdo do container à direita */
  margin-right: 40px;
`;

export const PaginationButton = styled.button`
  padding: 8px 12px;
  margin: 0 5px;
  border: 1px solid black; /* Alterado para preto */
  border-radius: 5px;
  cursor: pointer;
  color: black; /* Cor do texto definida como preto */

  &:hover {
    background-color: #007bff;
    color: #ffffff;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
